import "bootstrap/dist/css/bootstrap.min.css";
import { Suspense } from "react";
import { Helmet } from "react-helmet"; // Import react-helmet to handle metadata
import "react-datepicker/dist/react-datepicker.css";
import TopHeader from "./TopHeader"; // Corrected TopHeade to TopHeader
import SideNav from "./SideNav";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
  return (
    <div className="dashboard_wrapper">
      {/* Handle page metadata using react-helmet */}
      <Helmet>
        <title>Citric Hub Admin Portal</title>
        <meta name="description" content="" />
        {/* <link rel="icon" href="/Images/logo/logo.jpg" /> */}
      </Helmet>

      <Suspense fallback={<div>Loading...</div>}>
        <SideNav />
        <div className="routes_view">
          <TopHeader />
          <div className="main_page_wrapper">
            <Outlet></Outlet>
          </div>
        </div>
      </Suspense>
    </div>
  );
}
